// imove-start: 埋点初始化
import http from '@lib/http';

export default async function(ctx) {
  // 加载report组件
  
  return import('@tencent/wecalendar_web_base_report/dist/web.js').then((r) => {
    r.enableUserPayTag(http);
    return r;
  });
}